module.exports = __webpack_public_path__ + "img/1.2df5c1dc.jpg";